// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3f158ab1]{display:none}.sf-button--text[data-v-3f158ab1]{--button-background:transparent;--button-color:#2e2d2c}.sf-button--text[data-v-3f158ab1]:hover{--button-background:transparent;--button-color:#ea580c}.sf-button--text.is-disabled--button[data-v-3f158ab1]{--button-background:transparent;--button-color:#2e2d2c;opacity:.3}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
